"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("./constants");

var _sx = _interopRequireDefault(require("./sx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const colorStyles = ({
  scheme,
  ...props
}) => {
  return {
    color: scheme === 'secondary' ? (0, _constants.get)('colors.counter.text')(props) : scheme === 'primary' ? (0, _constants.get)('colors.counter.primary.text')(props) : (0, _constants.get)('colors.counter.text')(props)
  };
};

const bgStyles = ({
  scheme,
  ...props
}) => {
  return {
    backgroundColor: scheme === 'secondary' ? (0, _constants.get)('colors.counter.bg')(props) : scheme === 'primary' ? (0, _constants.get)('colors.counter.primary.bg')(props) : (0, _constants.get)('colors.counter.bg')(props)
  };
};

const CounterLabel = _styledComponents.default.span.withConfig({
  displayName: "CounterLabel",
  componentId: "sc-1ubx52d-0"
})(["display:inline-block;padding:2px 5px;font-size:", ";font-weight:", ";line-height:", ";border-radius:20px;", ";", ";", ";&:empty{display:none;}", ";"], (0, _constants.get)('fontSizes.0'), (0, _constants.get)('fontWeights.bold'), (0, _constants.get)('lineHeights.condensedUltra'), colorStyles, bgStyles, _constants.COMMON, _sx.default);

var _default = CounterLabel;
exports.default = _default;